export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-mobile-1.0.0',
    name: 'JDSDatepickerMobile'
  },
  hierarchy: {
    popup: ['jds_datepicker_mobile_internal']
  },
  base: {
    popup: {
      priority: 70,
      passive: true
    },
    jds_datepicker_mobile_internal: {
      state: 'default',
      open: false
    }
  },
  variant: {
    state: {
      month_view: {
        jds_datepicker_mobile_internal: {
          state: 'month_view'
        }
      },
      year_view: {
        jds_datepicker_mobile_internal: {
          state: 'year_view'
        }
      }
    },
    open: {
      true: {
        popup: {
          passive: false
        },
        jds_datepicker_mobile_internal: {
          open: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      state: {
        values: ['default', 'month_view', 'year_view']
      },
      open: {
        values: [false, true]
      }
    },
    data: {
      jds_datepicker_mobile_internal: {
        monthName: {
          type: 'string',
          name: 'monthName'
        },
        year: {
          type: 'string',
          name: 'year'
        },
        showArrows: {
          type: 'boolean',
          name: 'showArrows'
        },
        yearSelectable: {
          type: 'boolean',
          name: 'yearSelectable'
        },
        monthSelectable: {
          type: 'boolean',
          name: 'monthSelectable'
        },
        months: {
          type: 'list',
          name: 'months',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        },
        current: {
          type: 'number',
          name: 'year'
        },
        yearData: {
          type: 'object',
          name: 'yearData',
          object: {
            count: 'number',
            disabled: 'list',
            min: 'number',
            max: 'number'
          }
        },
        loadedYears: {
          type: 'list',
          name: 'loadedYears',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        },
        date: {
          type: 'number',
          name: 'date'
        },
        month: {
          type: 'number',
          name: 'month'
        },
        value: {
          type: 'date',
          name: 'value'
        },
        calendarData: {
          type: 'object',
          name: 'calendarData',
          object: {
            disabledDays: 'list',
            disabledDates: 'list',
            max: 'date',
            min: 'date'
          }
        },
        calendarDays: {
          type: 'JDSDatepickerCalendarHeader.days',
          name: '_calendarDays'
        },
        calendarRows: {
          type: 'JDSDatepickerCalendar.rows',
          name: '_calendarRows'
        },
        confirmDate: {
          type: 'string',
          name: 'confirmDate'
        }
      }
    },
    events: {
      jds_datepicker_mobile_internal: {
        onClose: 'onClose',
        onConfirm: 'onConfirm'
      }
    },
    a11y: {
      jds_datepicker_mobile_internal: {
        properties: {
          previousButtonAriaLabel: 'previousButtonAriaLabel',
          closeAriaLabel: 'closeAriaLabel',
          previousMonthAriaLabel: 'previousMonthAriaLabel',
          nextMonthAriaLabel: 'nextMonthAriaLabel',
          confirmAriaLabel: 'confirmAriaLabel'
        }
      }
    }
  }
};
